<template>
  <v-dialog
    v-model="showDialogWithdraw"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    width="700"
  >
    <v-card width="700" class="mx-auto">
      <v-form lazy-validation>
        <v-toolbar>
          <v-toolbar-title class="title">
            <span v-if="payment_providers.length == 0">
              {{ $t("tabWithdraw") }}
            </span>
            <span v-else>
              {{ toolbarTitle }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <!-- Alert Bank Verification Status when is NOT verified -->
        <!-- <div class="pa-2">
        <v-alert
          v-if="$isCreditOnline() && !verificationAlert"
          prominent
          dense
          type="warning"
        >
          <v-row align="center">
            <v-col class="grow d-flex align-center">
              {{ $t("invalidPixKey") }}
            </v-col>
            <v-col class="shrink">
              <v-btn
                v-if="this.$route.name !== '/'"
                color="primary"
                @click="
                  $router.push({
                    name: 'Perfil',
                    query: { status: bankVerificationStatus },
                    path: 'user/profile',
                  })
                "
                >{{ $t("settings") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-alert>
      </div> -->
        <!-- Alert END -->
        <v-container>
          <!-- aqui -->
          <div
            v-if="payment_providers.length == 0 && paymentMethodsFetched"
            style="min-height: 300px"
            class="d-flex align-center pa-5"
          >
            <div class="d-flex flex-column justify-center align-center">
              <v-icon size="72">mdi-bank-off-outline</v-icon>
              <h2 class="text-center mt-5">{{ $t("noPaymentMethodsMsg") }}</h2>
            </div>
          </div>
          <div v-else>
            <div
              v-if="payment_providers.length != 0"
              class="d-flex flex-column justify-center"
            >
              <div class="d-flex flex-column justify-center">
                <v-card class="py-4 px-4 grey darken-3 mx-auto mt-4">
                  <v-slide-group
                    v-model="slideModel"
                    center-active
                    :show-arrows="isMobile"
                    mandatory
                  >
                    <v-slide-item
                      v-for="method in payment_providers"
                      :key="method.uniqueId"
                      v-slot="{ active, toggle }"
                    >
                      <v-card
                        :color="active ? '#ffffff' : 'grey lighten-1'"
                        :style="
                          active
                            ? `border: solid 3px ${$vuetify.theme.themes.dark.primary}`
                            : ''
                        "
                        class="d-flex justify-center align-center mx-2"
                        width="150px"
                        height="77px"
                        flat
                        @click="toggle"
                      >
                        <div
                          class="d-flex flex-column justify-center align-center"
                        >
                          <img
                            :src="getMethodImage(method.uniqueId)"
                            width="70%"
                            :style="
                              method.uniqueId.includes('PixPaybrokers')
                                ? 'margin-top: 8px'
                                : ''
                            "
                          />
                        </div>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
                </v-card>
              </div>
              <div>
                <div v-if="loadingInfo" class="text-center my-8">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </div>
                <v-card-text
                  class="mx-auto mt-4"
                  style="max-width: 400px"
                  v-else-if="canWithdraw"
                >
                  <div
                    v-if="
                      currentPaymentProvider == 'PixPay4FunGO' ||
                        currentPaymentProvider == 'CarteiraPay4FunWallet'
                    "
                    :class="$vuetify.breakpoint.mobile ? 'mt-4' : ''"
                  >
                    <div
                      v-if="canWithdraw"
                      class="d-flex justify-space-between mb-4"
                    >
                      <div>
                        {{ $t("minValueDialog") }} {{ minPay4FunWithdraw }}
                      </div>
                      <div>{{ $t("maxValueDialog") }} 20.000</div>
                    </div>
                  </div>
                  <div
                    v-if="
                      currentPaymentProvider == 'PixPaybrokers' ||
                        currentPaymentProvider == 'PixPaybrokersV4' ||
                        currentPaymentProvider == 'PixBrasilCash' ||
                        currentPaymentProvider == 'PixPaag' ||
                        currentPaymentProvider == 'PixPaguePay' ||
                        currentPaymentProvider == 'PixPagFast'
                    "
                    :class="$vuetify.breakpoint.mobile ? 'mt-4' : ''"
                  >
                    <div
                      v-if="canWithdraw"
                      class="d-flex justify-space-between mb-4"
                    >
                      <div>
                        {{ $t("minValueDialog") }}
                        {{ $store.state.operators.min_withdraw }}
                      </div>
                      <!-- <div>Max. R$ 20.000</div> -->
                    </div>
                  </div>
                  <div class="mb-2">
                    <v-text-field
                      id="scrollToInput"
                      v-model="withdrawal"
                      type="number"
                      placeholder="00,00"
                      :label="$t('withdrawLabel')"
                      :prefix="$t('labelCurrency')"
                      hide-details="auto"
                      outlined
                      class="grey--text"
                      clearable
                      tabindex="2"
                      autofocus
                      @click="scrollToInputValue()"
                      :error="error"
                      :error-messages="errorMessage"
                    ></v-text-field>
                  </div>
                  <p>
                    {{ $t("withdrawText") }}
                  </p>
                  <p v-if="withdraw_tax">
                    {{ $t("withdrawTax") }} <span>{{ withdraw_tax }}</span>
                  </p>
                </v-card-text>
                <v-card-text v-else>
                  <h3
                    class="mb-5 text-center"
                    v-if="
                      withdrawErrorDetail !== $t('verifyEmailBeforeWithdraw')
                    "
                  >
                    {{ withdrawErrorMsg }}
                  </h3>
                  <p
                    class="text-center"
                    :class="{
                      'mt-5':
                        withdrawErrorDetail === $t('verifyEmailBeforeWithdraw'),
                    }"
                  >
                    {{ withdrawErrorDetail }}
                  </p>
                </v-card-text>
                <v-card-actions
                  class="pa-6 pt-0 mx-auto"
                  style="max-width: 400px"
                >
                  <v-btn
                    v-if="
                      withdrawErrorDetail === $t('verifyEmailBeforeWithdraw')
                    "
                    :loading="loading"
                    tabindex="8"
                    block
                    type="submit"
                    class="primary darken-1"
                    @click.prevent="verifyEmail"
                  >
                    {{ $t("confirmEmail") }}
                  </v-btn>

                  <v-btn
                    v-else
                    :loading="loading"
                    tabindex="8"
                    block
                    type="submit"
                    class="primary darken-1"
                    @click.prevent="getWithdrawal()"
                    :disabled="
                      disableWithdraw || loading || !canWithdraw || loadingInfo
                    "
                  >
                    {{ $t("BtnWithdraw") }}
                  </v-btn>
                </v-card-actions>
              </div>

              <WithdrawFooter
                :currentPaymentProvider="currentPaymentProvider"
              />
            </div>
            <div v-else>
              <v-skeleton-loader
                type="table-thead, image"
                style="width: auto;"
              ></v-skeleton-loader>
            </div>
          </div>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import theme from "@/plugins/theme";
import WithdrawFooter from "./WithdrawFooter";

export default {
  components: { WithdrawFooter },

  data: () => ({
    showDialogWithdraw: false,
    loadingInfo: null,
    withdraw_tax: null,
    canWithdraw: false,
    withdrawErrorMsg: "",
    withdrawErrorDetail: "",
    // form Withdrawal (saque ou retirada)
    loading: false,

    valid: false,
    withdrawal: null,

    disabled: false,
    // slide
    slideModel: null,
    payment_providers: [],
    error: false,
    errorMessage: "",
    paymentMethodsFetched: false,
    updateBalanceIntervalId: 0,
    updateBalanceCounter: 0,
  }),

  watch: {
    dialogWithdrawal(newValue) {
      // Dialog aberto
      if (newValue) {
        this.getWithdrawInfo();

        if (this.payment_providers.length == 0) {
          return;
        }

        this.slideModel = 0;
      }
      if (!newValue) {
        if (this.payment_providers.length == 0) {
          return;
        }

        this.slideModel = 0;
      }
    },
  },
  computed: {
    toolbarTitle() {
      const map = {
        PixPaybrokers: this.$t("withdrawalByPayBrokers"),
        PixPaybrokersV4: this.$t("withdrawalByPayBrokers"),
        PixPay4FunGO: this.$t("withdrawalByPay4FunGo"),
        CarteiraPay4FunWallet: this.$t("walletWithdrawalPay4Fun"),
        PixBrasilCash: this.$t("brazilCashWithdraw"),
        PixPaag: this.$t("paagWithdraw"),
        PixPaguePay: this.$t("paguePayWithdraw"),
        PixPagFast: this.$t("pagFastWithdraw"),
      };

      return map[this.currentPaymentProvider];
    },

    isMobile() {
      return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },

    // Retorna a soma do nome do método com o nome do gateway
    // Ex: PixPaybrokers, PixPay4FunGO, CarteiraPay4FunWallet, PixBrasilCash
    currentPaymentProvider() {
      if (this.payment_providers[this.slideModel]) {
        return this.payment_providers[this.slideModel].uniqueId;
      }

      return "";
    },

    minWithdraw() {
      return this.$store.state.operators.min_withdraw;
    },

    minPay4FunWithdraw() {
      if (this.$store.state.operators.min_withdraw > 20) {
        return this.$store.state.operators.min_withdraw;
      }

      return 20;
    },

    disableWithdraw() {
      if (
        this.currentPaymentProvider === "CarteiraPay4FunWallet" ||
        this.currentPaymentProvider == "PixPay4FunGO"
      ) {
        const minPay4FunWithdraw = this.minPay4FunWithdraw;
        const maxPay4FunDeposit = 20000;

        if (
          parseFloat(this.withdrawal) < minPay4FunWithdraw ||
          !this.withdrawal
        ) {
          this.error = true;
          this.errorMessage = `O valor mínimo do saque é R$ ${minPay4FunWithdraw}.`;
          return true;
        }

        if (parseFloat(this.withdrawal) > maxPay4FunDeposit) {
          this.errorMessage = `O valor máximo do saque é R$ ${maxPay4FunDeposit}.`;
          this.error = true;
          return true;
        }
      } else if (
        this.currentPaymentProvider == "PixPaybrokers" ||
        this.currentPaymentProvider === "PixPaybrokersV4" ||
        this.currentPaymentProvider == "PixPaag" ||
        this.currentPaymentProvider == "PixPaguePay" ||
        this.currentPaymentProvider == "PixPagFast"
      ) {
        if (
          parseFloat(this.withdrawal) < this.minWithdraw ||
          !this.withdrawal
        ) {
          this.error = true;
          this.errorMessage = `O valor mínimo do saque é R$ ${this.minWithdraw}.`;
          return true;
        }
      } else if (this.currentPaymentProvider === "PixBrasilCash") {
        if (
          parseFloat(this.withdrawal) < this.minWithdraw ||
          !this.withdrawal
        ) {
          this.error = true;
          this.errorMessage = `O valor mínimo do saque é R$ ${this.minWithdraw}.`;
          return true;
        }
      }

      this.error = false;
      this.errorMessage = "";
      return false;
    },

    // getUser() {
    //   return this.$store.getters.getUser;
    // },
    dialogWithdrawal() {
      return this.$store.state.dialogWithdrawal;
    },

    // pay4fun
    getMerchantLogo() {
      return this.$operatorLogoUrl(this.$domain());
    },
  },

  mounted() {
    if (this.dialogWithdrawal) {
      this.getWithdrawInfo();
    }
  },

  methods: {
    verifyEmail() {
      this.closeDialog();

      this.$router.push({
        name: "Verify",
        query: { open: "email_verification" },
      });
    },
    updatePaymentMethods() {
      // Vamos atualizar os métodos de pagamento
      this.paymentMethodsFetched = false;

      this.$axios
        .get("/player/online/bank/listPaymentMethods")
        .then((res) => {
          this.payment_providers = res.data.dados
            .filter(
              (method) =>
                method.fluxo === "2" &&
                method.method_status === "1" &&
                method.nome_metodo !== "Boleto"
            )
            .map((m) => ({ ...m, uniqueId: m.nome_metodo + m.nome_gateway }));
        })
        .catch(() => {
          this.payment_providers = [];
        })
        .finally(() => {
          this.paymentMethodsFetched = true;
        });
    },

    getWithdrawInfo() {
      this.loadingInfo = true;

      this.withdrawErrorDetail = "";

      this.$axios
        .get("/player/online/bank/withdrawInfo")
        .then((res) => {
          this.updatePaymentMethods();

          if (res.data.dados.can_withdraw) {
            this.canWithdraw = true;

            if (res.data.dados.taxa_saque != 0) {
              this.withdraw_tax = `${res.data.dados.taxa_saque * 100}%`;
            }
          } else {
            this.withdrawErrorMsg = res.data.messages;
            this.withdrawErrorDetail = res.data.dados.nextWithdrawDate;
            this.canWithdraw = false;

            if (
              res.data.dados.reason &&
              res.data.dados.reason === "email_not_validated"
            ) {
              this.withdrawErrorDetail = this.$t("verifyEmailBeforeWithdraw");
            }
          }

          if (this.dialogWithdrawal) {
            this.showDialogWithdraw = true;
          }
        })
        // Caso dê algum erro ao fetchar a info, é melhor deixar o usuário continuar tentando fazer saques (o backend impede se ele estiver limitado)
        .catch(() => {
          this.canWithdraw = true;

          this.closeDialog();
        })
        .finally(() => {
          this.loadingInfo = false;
        });
    },

    closeDialog() {
      this.$store.commit("dialogWithDrawal", false);
      this.showDialogWithdraw = false;
      this.withdrawal = "";
      this.refreshCash();
    },

    async withdrawPaybrokers() {
      this.loading = true;

      const body = {
        value: Number(this.withdrawal).toFixed(2),
      };

      let endpoint = "/player/online/bank/withdrawOnline";

      if (this.currentPaymentProvider === "PixPaybrokersV4") {
        endpoint = "/player/payments/paybrokers/withdrawOnline";
      }

      // Post saque
      await this.$axios
        .post(endpoint, this.$formdata(body))
        .then((resp) => {
          this.$store.commit("setNotification", {
            color: "green",
            msg: resp.data.messages,
          });
        })
        .then(() => {
          // Register Event generate_saque Analytics
          this.$gtag.generate_saque(body.value);
        })
        .then(() => {
          this.closeDialog();
          this.refreshCash();
          this.refreshTableBank();
        })
        .catch((error) => {
          this.$store.commit("setNotification", {
            color: "warning",
            msg: error.response.data.messages.error,
          });
        })
        .finally(() => {
          // this.getWithdrawInfo();
          this.loading = false;
        });
    },

    async withdrawPayForFun() {
      this.loading = true;

      const body = {
        // amount: "20.00",
        amount: parseFloat(this.withdrawal).toFixed(2),
        merchantLogo: this.getMerchantLogo,
        layoutColor: theme.colorAppBar,
      };

      try {
        if (this.currentPaymentProvider == "PixPay4FunGO") {
          const response = await this.$axios.post(
            "/player/online/bank/withdrawOnlinePayForFun",
            this.$formdata(body)
          );
          const redirectToURL = Object.values(response.data.dados).toString();
          try {
            // window.location.href = redirectToURL;

            // Vamos começar a escutar se houve alguma modificação no saldo dele
            this.updateBalanceIntervalId = setInterval(() => {
              this.refreshCash();
            }, 5000);

            // Redireciona para uma nova tab para fins de debug
            window.open(redirectToURL);
          } catch (error) {
            console.log(error);
          }
        } else {
          const response = await this.$axios.post(
            "/player/online/bank/withdrawWalletOnlinePayForFun",
            this.$formdata(body)
          );

          if (response.data.dados.error === "customer_not_found") {
            const registerAccountLink =
              this.$domain() === "sys"
                ? "https://test.p4f.com/Account/Register"
                : "https://p4f.com/Account/Register";

            window.open(registerAccountLink, "_blank");
          } else {
            this.$store.commit("setNotification", {
              msg: response.data.messages,
              color: "success",
            });
          }
        }
      } catch (error) {
        console.log(error);
        const msg = error.response.data.messages.error;
        const color = "warning";
        this.$store.commit("setNotification", { msg, color });
      } finally {
        this.loading = false;
        this.closeDialog();
      }
    },

    withdrawBrasilCash() {
      this.loading = true;

      const value = Number(this.withdrawal).toFixed(2);

      const body = {
        value,
      };

      this.$axios
        .post("/player/online/bank/withdrawBrasilCash", this.$formdata(body))
        .then((resp) => {
          this.$store.commit("setNotification", {
            color: "green",
            msg: resp.data.messages,
          });

          this.$gtag.generate_saque(value);
          this.refreshTableBank();
          this.refreshCash();
          this.closeDialog();
        })
        .catch((error) => {
          this.$store.commit("setNotification", {
            color: "warning",
            msg: error.response.data.messages.error,
          });
        })
        .finally(() => {
          // this.getWithdrawInfo();
          this.loading = false;
        });
    },

    async paagWithdraw() {
      this.loading = true;
      const body = {
        value: Number(this.withdrawal).toFixed(2),
      };
      // Post saque
      await this.$axios
        .post("/player/payments/paag/withdrawPaag", this.$formdata(body))
        .then((resp) => {
          this.$store.commit("setNotification", {
            color: "green",
            msg: resp.data.messages,
          });
        })
        .then(() => {
          // Register Event generate_saque Analytics
          this.$gtag.generate_saque(body.value);
        })
        .then(() => {
          this.closeDialog();
          this.refreshCash();
          this.refreshTableBank();
        })
        .catch((error) => {
          this.$store.commit("setNotification", {
            color: "warning",
            msg: error.response.data.messages.error,
          });
        })
        .finally(() => {
          // this.getWithdrawInfo();
          this.loading = false;
        });
    },

    async paguePayWithdraw() {
      this.loading = true;

      const body = {
        value: Number(this.withdrawal).toFixed(2),
      };

      const endpoint = "/player/payments/paguePay/withdrawOnline";

      await this.$axios
        .post(endpoint, this.$formdata(body))
        .then((resp) => {
          this.$store.commit("setNotification", {
            color: "green",
            msg: resp.data.messages,
          });
        })
        .then(() => {
          // Register Event generate_saque Analytics
          this.$gtag.generate_saque(body.value);
        })
        .then(() => {
          this.closeDialog();
          this.refreshCash();
          this.refreshTableBank();
        })
        .catch((error) => {
          this.$store.commit("setNotification", {
            color: "warning",
            msg: error.response.data.messages.error,
          });
        })
        .finally(() => {
          this.getWithdrawInfo();
          this.loading = false;
        });
    },

    async pagFastWithdraw() {
      this.loading = true;
      const body = {
        value: Number(this.withdrawal).toFixed(2),
      };
      const endpoint = "/player/payments/pagFast/withdrawOnline";
      await this.$axios
        .post(endpoint, this.$formdata(body))
        .then((resp) => {
          this.$store.commit("setNotification", {
            color: "green",
            msg: resp.data.messages,
          });
        })
        .then(() => {
          // Register Event generate_saque Analytics
          this.$gtag.generate_saque(body.value);
        })
        .then(() => {
          this.closeDialog();
          this.refreshCash();
          this.refreshTableBank();
        })
        .catch((error) => {
          this.$store.commit("setNotification", {
            color: "warning",
            msg: error.response.data.messages.error,
          });
        })
        .finally(() => {
          this.getWithdrawInfo();
          this.loading = false;
        });
    },


    // Withdrawal (SAQUE)
    async getWithdrawal() {
      if (
        this.currentPaymentProvider == "PixPaybrokers" ||
        this.currentPaymentProvider == "PixPaybrokersV4"
      ) {
        this.withdrawPaybrokers();
      } else if (
        this.currentPaymentProvider == "PixPay4FunGO" ||
        this.currentPaymentProvider == "CarteiraPay4FunWallet"
      ) {
        this.withdrawPayForFun();
      } else if (this.currentPaymentProvider == "PixBrasilCash") {
        this.withdrawBrasilCash();
      } else if (this.currentPaymentProvider === "PixPaag") {
        this.paagWithdraw();
      } else if (this.currentPaymentProvider === "PixPaguePay") {
        this.paguePayWithdraw();
      } else if (this.currentPaymentProvider === "PixPagFast") {
        this.pagFastWithdraw();
      }
    },

    refreshCash() {
      this.$axios.get("/player/online/bank/balanceOnline").then((resp) => {
        if (this.updateBalanceIntervalId > 0) {
          if (this.updateBalanceCounter === 4) {
            clearInterval(this.updateBalanceIntervalId);
            this.updateBalanceIntervalId = 0;
            this.updateBalanceCounter = 0;
          } else {
            this.updateBalanceCounter++;
          }

          if (this.$store.state.cash > resp.data.dados.balance) {
            clearInterval(this.updateBalanceIntervalId);
            this.updateBalanceIntervalId = 0;
            this.updateBalanceCounter = 0;
          }
        }

        this.$store.commit("setCash", resp.data.dados.balance);
        this.$store.commit("setBonus", {
          value: resp.data.dados.balance_bonus,
          status: resp.data.dados.balance_bonus_status,
        });
        this.$store.commit("setAvailableBalance", resp.data.dados.available_balance);
        this.$store.commit("setRestrictedBalance", resp.data.dados.restricted_balance);
      });
    },

    refreshTableBank() {
      this.$store.commit("refreshTableBank", true);
    },

    scrollToInputValue() {
      document
        .getElementById("scrollToInput")
        .scrollIntoView({ behavior: "smooth" });
    },

    getMethodImage(methodUniqueId) {
      const map = {
        PixPaybrokers: "paybrokers-logo",
        PixPaybrokersV4: "paybrokers-logo",
        PixPay4FunGO: "pay4fungo_pix",
        CarteiraPay4FunWallet: "Pay4Funlogo",
        PixBrasilCash: "brasilCash",
        PixPaag: "paag",
        PixPaguePay: "paguePay",
        PixPagFast: "pagFast",
      };

      return this.$paymentMethodLogoUrl(methodUniqueId, map[methodUniqueId]);
    },
  },
};
</script>
